<template>
  <div class="home">
    <div
      class=" flex flex-col sticky z-10 shadow bg-white mb-12 w-full"
      style="top: 50px"
    >
      <div class="flex px-8 items-center py-4 mb-4 justify-between">
        <div class="page-heading text-2xl font-semibold">Rewards</div>
      </div>
      <div
        class="relative mx-12 border border-gray-300 focus:shadow-md focus:border-none flex-col rounded-full flex mb-6"
      >
        <input
          class="w-full leading-tight h-10 border-none px-4 bg-gray-200 focus:bg-white focus:outline-none rounded-full pl-10"
          v-model="quickSearch"
          placeholder="Search Rewards"
          type="text"
        />
        <div
          class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
        >
          <svg
            class="fill-current pointer-events-none text-gray-600 w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path
              d="M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    <div class="block sm:flex sm:justify-even sm:flex-wrap">
      <card v-for="x in filteredRecords" :reward="x" :key="x.id" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      quickSearch: "",
      list: [],
    };
  },
  computed: {
    filteredRecords() {
      let data = this.list.filter((row) => {
        return Object.keys(row).some((key) => {
          return (
            String(row[key])
              .toLowerCase()
              .indexOf(this.quickSearch.toLowerCase()) > -1
          );
        });
      });

      return data;
    },
  },
  components: {
    card: () => import("@/components/tenant/reward-card"),
  },
  methods: {
    ...mapMutations(["updateLoader"]),
    ...mapActions(["tenantFetchAllRewards"]),
    async loadData() {
      this.updateLoader(true);
      let res = await this.tenantFetchAllRewards();
      this.list = res.data.data.rewards;
      this.updateLoader(false);
    },
  },
  async mounted() {
    this.loadData();

    this.$Bus.$on("fetch-rewards", (data) => {
      this.loadData();
    });
  },
};
</script>
